import React from 'react';
import SettingsTable from './SettingsTable';

const SettingsView = ({ onOpenHelp }) => {
  return (
    <>
      <SettingsTable onOpenHelp={onOpenHelp} />
    </>
  );
};

export default SettingsView;
